import { API_URL } from '../config';

/**
 * Play a sound by its name
 * @param soundName The name of the sound file (without extension)
 */
export const playSound = (soundName: string): void => {
  if (soundName === 'none') return;
  
  console.log(`Attempting to play sound: ${soundName}`);
  // Use API_URL to correctly reference server path
  const audio = new Audio(`${API_URL}/sounds/${soundName}.mp3`);
  audio.volume = 1.0; // Ensure volume is set to maximum
  
  // Add event listeners for debugging
  audio.addEventListener('canplaythrough', () => {
    console.log(`Sound ready to play: ${soundName}`);
    audio.play()
      .then(() => console.log(`Playing sound: ${soundName}`))
      .catch(error => console.error('Error playing sound:', error));
  });
  
  audio.addEventListener('error', (e) => {
    console.error(`Audio error (${soundName}):`, e);
  });
  
  // Force load the audio
  audio.load();
}; 